import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-detalhes-pdv',
  templateUrl: './modal-detalhes-pdv.component.html',
  styleUrls: ['./modal-detalhes-pdv.component.css']
})
export class ModalDetalhesPdvComponent {

  @Input() solicitacao: any;

  constructor(public activeModal: NgbActiveModal){

   }

   getRefundStatusColor(status: number) {
    let color = '#707070';
    if (status == 1) {
      color = '#E4E408'
    } else if (status == 2) {
      color = '#3CCB1B';
    } else if (status == 3) {
      color = '#3D8EEB'
    } else if (status == 4) {
      color = '#EF3F3F'
    }
    return color;
  }

}
